"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _link = _interopRequireDefault(require("next/link"));
var _router = require("next/router");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _config = require("../../../content/config");
var getPrefixedAs = function getPrefixedAs(href) {
  var route = (_config.config.routePrefix + href).replace(/\/$/, ''); // remove trailing slash;
  return route || '/';
};
var NextLink = function NextLink(_ref) {
  var href = _ref.href,
    children = _ref.children,
    className = _ref.className,
    external = _ref.external,
    id = _ref.id;
  var router = (0, _router.useRouter)();
  var query = router.query;
  var hrefAs = {
    pathname: getPrefixedAs(href),
    query: query
  };
  return external ? /*#__PURE__*/_react["default"].createElement(_link["default"], {
    href: href,
    legacyBehavior: true
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: className,
    target: "_blank",
    rel: "noopener noreferrer",
    id: id
  }, children)) : /*#__PURE__*/_react["default"].createElement(_link["default"], {
    href: hrefAs,
    legacyBehavior: true
  }, /*#__PURE__*/_react["default"].createElement("a", {
    id: id,
    className: className
  }, children));
};
NextLink.propTypes = {
  href: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].any,
  className: _propTypes["default"].string,
  external: _propTypes["default"].bool,
  id: _propTypes["default"].string
};
var _default = exports["default"] = NextLink;